import { render, staticRenderFns } from "./MyProjectsContractDetails.vue?vue&type=template&id=4294b542&scoped=true"
import script from "./MyProjectsContractDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsContractDetails.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsContractDetails.vue?vue&type=style&index=0&id=4294b542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4294b542",
  null
  
)

export default component.exports